var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90085 0C5.51356 0 5.16969 0.24471 5.04712 0.607559L4.35151 2.66667H1.4C0.902944 2.66667 0.5 3.06464 0.5 3.55556V15.1111C0.5 15.602 0.902944 16 1.4 16H17.6C18.0971 16 18.5 15.602 18.5 15.1111V3.55556C18.5 3.31981 18.4052 3.09372 18.2364 2.92702C18.0676 2.76032 17.8387 2.66667 17.6 2.66667L14.6489 2.66667L13.9547 0.608037C13.8323 0.244944 13.4883 0 13.1009 0H5.90085ZM5.85373 3.83689L6.54934 1.77778H12.452L13.1461 3.83641C13.2685 4.19951 13.6125 4.44445 14 4.44445L16.7 4.44445V14.2222H2.3V4.44445H5C5.38729 4.44445 5.73116 4.19974 5.85373 3.83689ZM12.2 8.88889C12.2 10.3616 10.9912 11.5556 9.5 11.5556C8.00883 11.5556 6.8 10.3616 6.8 8.88889C6.8 7.41613 8.00883 6.22222 9.5 6.22222C10.9912 6.22222 12.2 7.41613 12.2 8.88889ZM14 8.88889C14 11.3435 11.9853 13.3333 9.5 13.3333C7.01472 13.3333 5 11.3435 5 8.88889C5 6.43429 7.01472 4.44444 9.5 4.44444C11.9853 4.44444 14 6.43429 14 8.88889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.c731bd31347705f752b3965677f52e11.svg";
export { ForwardRef as ReactComponent };